/** Stripe price/product mapping for Viraluj subscription tiers */

export const STRIPE_TIERS = {
  starter: {
    monthly: {
      priceId: "price_1TlY7s0cNUHDYND63MsPLm67",
      productId: "prod_UIdrCBOusVJR9a",
      amount: 59,
    },
    yearly: {
      priceId: "price_1TlY9s0cNUHDYND6LD5aHmkt",
      productId: "prod_UIdr2GkGU1Fssr",
      amount: 559,
      monthlyEquivalent: 47,
    },
  },
  pro: {
    monthly: {
      priceId: "price_1TlYAs0cNUHDYND6ecmxvj35",
      productId: "prod_UIdr90qg7kSpPm",
      amount: 149,
    },
    yearly: {
      priceId: "price_1TlYBj0cNUHDYND64ibz0dzk",
      productId: "prod_UIdrjD34V2f1fF",
      amount: 1339,
      monthlyEquivalent: 112,
    },
  },
} as const;

/** Map product IDs back to tier names */
export const PRODUCT_TO_TIER: Record<string, string> = {
  [STRIPE_TIERS.starter.monthly.productId]: "starter",
  [STRIPE_TIERS.starter.yearly.productId]: "starter",
  [STRIPE_TIERS.pro.monthly.productId]: "pro",
  [STRIPE_TIERS.pro.yearly.productId]: "pro",
};
